import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { organizationSchema } from '@/lib/services/organizations/organization.schema'
import { organizationQueries } from '@/lib/services/organizations/organizations.query'
import { canEditOrganization } from '@/lib/services/organizations/organizations.access'
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/organizations/$organizationId')({
  component: OrganizationDetailLayout,
  head: adminRouteTitleHead,
  params: {
    parse: (params) => organizationSchema.pick({ organizationId: true }).parse(params),
  },
  loader: async ({ context, params }) => {
    if (!context.ability.can('view', 'organizations')) throw notFound()
    const organization = await context.queryClient.ensureQueryData(
      organizationQueries.show(params.organizationId)
    )

    return { organization, isReadOnly: !canEditOrganization(context.ability, organization) }
  },
})

function OrganizationDetailLayout() {
  return <Outlet />
}
